import styled from '@emotion/styled';
import Button from "@material-ui/core/Button";


export const PlayButton = styled(Button)`
  &.MuiButton-root {
    background: #fff;
    color: #2f2f2f;
    border: 1px solid #2f2f2f;
    box-shadow: none;
    &:hover {
      background: #fff;
      box-shadow: none;
    }
  }
`;